

// src/app/login/page.tsx
'use client';

import { CasosPage } from '../../sections/casos/CasosPage';



export default function CasosPages() {
  return <CasosPage />;
}